<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AddOppositeStreet',
  props: {
    onChecked: Function,
    price: String | Number,
    popUpHeadline: String,
    popUpText: String,
    checkBoxId: String,
    fill: Boolean,
    enablePopUp: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPopUp: false,
      headline: 'Zusätzlich gegenüberliegende Straßenseite sperren',
      popUpHeadlineMerged: this.popUpHeadline || 'Beidseitige Halteverbotszone + ',
      checkBoxID: 'checkbox-id-1' + this.checkBoxId
    };
  },
  computed: {
    ...mapGetters(['priceInfo', 'priceNotExists', 'formData', 'prices', 'customer']),
    getZipCodeCityAndPrice() {
      if (!this.computeTotalOpposite()) {
        return '';
      }
      if (this.customer && (this.customer.bsr || !customer.kuchenaktuell)) {
        return '';
      }
      return `<strong class="step2-price">  + ${this.computeTotalOpposite()} €</strong>`;
    }
  },
  methods: {
    togglePopUp: function() {
      this.showPopUp = !this.showPopUp;
    },
    computeTotalOpposite: function() {
      if (this.formData.oppositeStreet === true) {
        if (this.checkBoxId === 'opposite-street-level-1') {
          return (
            this.priceInfo.beidseitig_aufstellung +
            (this.formData.dateFrom === this.formData.dateTo
              ? 0
              : this.prices.days * this.priceInfo.beidseitig_aufstellung_zuschlag)
          );
        }
      }
      if (
        this.prices &&
        this.prices.secondForm &&
        this.formData &&
        this.formData.secondForm &&
        this.formData.secondForm.oppositeStreet === true
      ) {
        if (this.checkBoxId === 'opposite-street-level-2' && this.formData.secondForm.oppositeStreet === true) {
          return (
            this.priceInfo.secondFormPrice.beidseitig_aufstellung +
            (this.formData.secondForm.dateFrom === this.formData.secondForm.dateTo
              ? 0
              : this.prices.secondForm.days * this.priceInfo.secondFormPrice.beidseitig_aufstellung_zuschlag)
          );
        }
      }
      return null;
    }
  }
};
</script>

<template>
  <div class="form-details-add-opposite-street">
    <div class="mb-10">
      <strong class="options">
        <input @change="onChecked" class="mr-10" :id="checkBoxID" type="checkbox" v-if="fill" checked />
        <input @change="onChecked" class="mr-10" :id="checkBoxID" type="checkbox" v-else />
        <label :for="checkBoxID" class="inline">
          <strong>{{ headline }}</strong>
        </label>
        <strong v-html="getZipCodeCityAndPrice" />
      </strong>

      <div
        v-if="enablePopUp"
        @mouseover="togglePopUp"
        @mouseout="togglePopUp"
        class="form-details-add-opposite-street-badge"
      >
        <i class="fa fa-info" />
        <div v-if="showPopUp" class="form-details-add-opposite-street-popup">
          <div class="arrow"></div>
          <h3 class="popover-title" v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
            {{
              popUpHeadlineMerged +
                ' ' +
                Number(
                  this.priceInfo.beidseitig_aufstellung +
                    (this.formData.dateFrom === this.formData.dateTo
                      ? 0
                      : this.prices.days * this.priceInfo.beidseitig_aufstellung_zuschlag)
                )
            }}
            €
          </h3>
          <h3 v-else class="popover-title">{{ popUpHeadlineMerged }}</h3>
          <div class="popover-content">{{ popUpText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import 'AddOppositeStreetStyles';
</style>
